import { useTranslate } from '@tolgee/react';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  message,
  showNextButton,
  confirmDisabled = false
}) => {
  const { t } = useTranslate();
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button size="sm" variant="secondary" onClick={handleClose}>
          {t('confirmModal.cancel')}
        </Button>
        <Button
          size="sm"
          variant="primary"
          onClick={handleConfirm}
          disabled={confirmDisabled}
        >
          {showNextButton ? t('confirmModal.next') : t('confirmModal.continue')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
